import * as React from "react";
import {
	TitleText,
	ToastMain,
	ToastWrapper,
	ToastMessage,
	CloseBtn,
	OKBtn,
	SuccessIcon,
	Toast,
} from "./styles";
import { getLitbLangFn } from "utils/language";

// const SUCCESSIMG = require("./image/right.png");
// const CloseImg = require("./image/close.png");

export const IOSNOLOGINSTATUS = 6; // IOS 未登录状态码

const SUCCESSIMG = "https://i.ezbuy.sg/FkieMxPmvO_9sJZXgjW_RbFPuhDq";
const CloseImg = "https://i.ezbuy.sg/FhYcSLDzkvBNtq4pts-5qsidTRfG";
export const getTextByStatus = (status: number, lang: string = "en") => {
	switch (status) {
		case 1:
			return `${getLitbLangFn("Awesome Coupons are at your fingertips!", lang)}`;
			break;
		case 2:
			return `${getLitbLangFn(
				"These Coupons have run out. <br/>Check back soon! More surprises waiting for you everyday!",
				lang,
			)}`;
			break;
		case 3:
			return `${getLitbLangFn(
				"You have already got these Coupons. <br/>Please come back tomorrow.",
				lang,
			)}`;
			break;
		case 4:
			return `${getLitbLangFn(
				'Check your <a href="%s">Coupons</a> account now.',
				lang,
			)}`.replace(`href="%s"`, "");
			break;
		case IOSNOLOGINSTATUS:
			return "Please go to the login page to log in, and then come here to get coupon";
			break;
		default:
			return `${getLitbLangFn(
				'Check your <a href="%s">Coupons</a> account now.',
				lang,
			)}`.replace(`href="%s"`, "");
	}
};
export interface LTReceiveToastProps {
	isMobile: boolean;
	status: number;
	lang: string;
	onClose: () => void;
}

export const LTReceiveToast = (props: LTReceiveToastProps) => {
	const { isMobile = false, onClose, status = -1, lang = "en" } = props;
	return (
		<ToastWrapper isMobile={isMobile}>
			<Toast isMobile={isMobile}>
				<CloseBtn isMobile={isMobile}>
					<img src={CloseImg} onClick={onClose} />
				</CloseBtn>
				<ToastMain>
					{status === 4 && (
						<React.Fragment>
							<SuccessIcon isMobile={isMobile}>
								<img src={SUCCESSIMG} />
							</SuccessIcon>
							<TitleText>{`${getLitbLangFn(
								"Received successfully",
								lang,
							)}`}</TitleText>
						</React.Fragment>
					)}
					<ToastMessage
						style={{ paddingTop: status !== 4 ? "12px" : "" }}
						dangerouslySetInnerHTML={{
							__html: getTextByStatus(status, lang),
						}}
					/>
					<OKBtn isMobile={isMobile}>
						<p onClick={onClose}>{`${getLitbLangFn("OK", lang)}`}</p>
					</OKBtn>
				</ToastMain>
			</Toast>
		</ToastWrapper>
	);
};
